'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialDropbox = function IoSocialDropbox(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.8 6l6.2 5.2-8.9 5.5-6.1-4.9z m-8.8 15.6l6.1-4.9 8.9 5.5-6.2 5.1z m15 0.6l8.9-5.5 6.1 4.9-8.8 5.7z m15-10.4l-6.1 4.9-8.9-5.5 6.2-5.2z m-15 11.5l6.3 5.1 2.6-1.7v2l-8.9 5.3-8.9-5.3v-2l2.7 1.7z' })
        )
    );
};

exports.default = IoSocialDropbox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-dropbox.js
// module id = 2669
// module chunks = 0